module.exports = __webpack_public_path__ + "assets/018342a91cc3615b3daea94bc618f81b.png";